import Link from "next/link";
import getConfig from "next/config";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const ResponsiveHeroBanner = ({ banner }) => {
  const desktopImage = banner.images?.[0]?.file;
  const tabletImage = banner.images_tablet?.[0]?.file;
  const mobileImage = banner.images_mobile?.[0]?.file;

  const link =
    banner.images?.[0]?.link ||
    banner.images_mobile?.[0]?.link ||
    banner.images_tablet?.[0]?.link;

  const hasImage = desktopImage || tabletImage || mobileImage;

  if (!hasImage) {
    return null;
  }

  if (link) {
    return (
      <Link href={link}>
        <a title="">
          {mobileImage && (
            <img
              src={`${settings.cdn}${mobileImage}`}
              className="w-full sm:hidden"
              alt=""
            />
          )}

          {tabletImage && (
            <img
              src={`${settings.cdn}${tabletImage}`}
              className="w-full hidden sm:block lg:hidden rounded-tr-lg rounded-bl-lg"
              alt=""
            />
          )}

          {desktopImage && (
            <img
              src={`${settings.cdn}${desktopImage}`}
              className="w-full hidden lg:block rounded-tr-lg rounded-bl-lg"
              alt=""
            />
          )}
        </a>
      </Link>
    );
  }

  return (
    <>
      {mobileImage && (
        <img
          src={`${settings.cdn}${mobileImage}`}
          className="w-full sm:hidden"
          alt=""
        />
      )}

      {tabletImage && (
        <img
          src={`${settings.cdn}${tabletImage}`}
          className="w-full hidden sm:block lg:hidden rounded-tr-lg rounded-bl-lg"
          alt=""
        />
      )}

      {desktopImage && (
        <img
          src={`${settings.cdn}${desktopImage}`}
          className="w-full hidden lg:block rounded-tr-lg rounded-bl-lg"
          alt=""
        />
      )}
    </>
  );
};

export default ResponsiveHeroBanner;
